






































import {
  ComponentInternalInstance,
  computed,
  getCurrentInstance,
  reactive,
  SetupContext,
  watch,
} from '@vue/composition-api';
import _ from 'lodash';
import { DialogPlugin } from 'tdesign-vue';
import i18n, { i18n_t } from '@/locales/i18n';
import { useEggHandler } from '@/renderer/scripts/composition/useEggHandler';
import storage from '@/renderer/scripts/utils/storage';
import ipc, { IpcEvents } from '@/renderer/scripts/utils/ipc';
import { SystemSetting } from '@/renderer/scripts/utils/storage/StoreKey';
import tips from '@/renderer/scripts/utils/tips';
import CustomDialog from '@/renderer/scripts/utils/CustomDialog';
import { IS_PC_IN_LINUX, IS_PC_IN_MAC, IS_PC_IN_WIN } from '@/common/constant/platform';
import { addSysSyncEntry, removeSysSyncEntry } from '@/renderer/scripts/utils/syncTaskLinkHelper';

import { getChannelFromVersionString, getVersionFromVersionString } from '@/renderer/scripts/utils/tools';

// const language = ref('system');
// const languageOptions = [{
//   label: '跟随操作系统',
//   value: 'system',
// }, {
//   label: '中文（简体）',
//   value: 'Chinese',
// }, {
//   label: 'English',
//   value: 'English',
// }];
export default {
  name: 'SystemSetting',
  setup(props: any, context: SetupContext) {
    // 当前组件
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const systemSetting = reactive<SystemSetting>({
      autoStart: false,
      minToTray: true,
      autoUpdate: true,
      syncVirtualDisk: true,
    });
    const methods = {
      getShowVersionText(versionString: string) {
        const version = getVersionFromVersionString(versionString);
        const channel = getChannelFromVersionString(versionString);
        if (channel.length) {
          return `${version}(${channel})`;
        }
        return version;
      },
      clearCache() {
        ipc.invoke(IpcEvents.INVOKE_OPERATE_MAIN_LISTENER, {
          event: 'clearCache',
        });
        tips.success(i18n_t('清理成功'));
      },
    };
    // 连续点击5次的彩蛋
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const { eggClick } = useEggHandler(5, () => {});
    const syncVirtualDiskText = computed(() => {
      if (IS_PC_IN_WIN) return i18n_t('添加本地同步盘符');
      if (IS_PC_IN_MAC) return i18n_t('添加同步目录到访达边栏');
      return '';
    });
    const onUpdate = () => {
      const { hasNewVersion, updateLoading } = vm.$store.getters;
      if (hasNewVersion && !updateLoading) {
        const dialog = CustomDialog.confirm({
          header: i18n_t('更新'),
          body: i18n_t('获取到最新版本，{slot1}', {
            slot1: !IS_PC_IN_LINUX ? i18n_t('是否立即更新？') : i18n_t('请联系管理员下载安装。'),
          }),
          placement: 'center',
          theme: 'warning',
          confirmBtn: !IS_PC_IN_LINUX ? i18n_t('确认') : i18n_t('好的'),
          cancelBtn: !IS_PC_IN_LINUX ? i18n_t('取消') : null,
          onConfirm: () => {
            if (dialog.hide) {
              dialog.hide();
            }
            if (!IS_PC_IN_LINUX) {
              ipc.emit(ipc.RENDERER_EVENTS_MAP.UPDATE_NOW);
              context.emit('close');
            }
          },
        });
      }
    };
    const checkUpdate = () => {
      ipc.emit(ipc.RENDERER_EVENTS_MAP.CHECK_UPDATE);
    };
    const onSystemChange = _.debounce(
      () => {
        const storageSystemSetting: SystemSetting = storage.get<SystemSetting>(storage.StoreKey.SYSTEM_SETTING);
        if (
          storageSystemSetting.autoStart === systemSetting.autoStart &&
          storageSystemSetting.minToTray === systemSetting.minToTray &&
          storageSystemSetting.autoUpdate === systemSetting.autoUpdate &&
          storageSystemSetting.syncVirtualDisk === systemSetting.syncVirtualDisk
        ) {
          return;
        }

        // 判断是否需要创建虚拟盘符
        if (systemSetting.syncVirtualDisk) {
          addSysSyncEntry();
        } else {
          removeSysSyncEntry();
        }

        storage.set(storage.StoreKey.SYSTEM_SETTING, systemSetting);
        ipc.invoke(IpcEvents.INVOKE_OPERATE_MAIN_LISTENER, {
          event: 'setAutoStart',
          params: {
            autoStart: systemSetting.autoStart,
          },
        });
      },
      2000,
      {
        leading: true,
      },
    );

    watch(systemSetting, () => {
      onSystemChange();
    });
    const storageSystemSetting: any = storage.get<SystemSetting>(storage.StoreKey.SYSTEM_SETTING);
    if (storageSystemSetting) {
      systemSetting.autoStart = storageSystemSetting.autoStart;
      systemSetting.minToTray = storageSystemSetting.minToTray;
      systemSetting.autoUpdate = storageSystemSetting.autoUpdate;
      systemSetting.syncVirtualDisk = storageSystemSetting.syncVirtualDisk;
    }
    return {
      eggClick,
      systemSetting,
      onUpdate,
      checkUpdate,
      syncVirtualDiskText,
      methods,
    };
  },
};
